import Vuex, { Store } from 'vuex';
import Vue from 'vue';

// eslint-disable-next-line import/no-named-as-default
import VuexPersistence from 'vuex-persist';

import Common from './modules/Common';
import AlertHelper from './modules/AlertHelper';
import LeaveAlertHelper from './modules/LeaveAlertHelper';
import MediaPopupHelper from './modules/MediaPopupHelper';
import RemoveHelper from './modules/RemoveHelper';
import TimetableHelper from './modules/TimetableHelper';

Vue.use(Vuex)


export default new Store({
  namespaced: true,
  modules: {
    Common,
    AlertHelper,
    LeaveAlertHelper,
    MediaPopupHelper,
    RemoveHelper,
    TimetableHelper
  },
  plugins: [
    new VuexPersistence({
      key: 'vuex',
      storage: window.localStorage,
      modules: [],
    }).plugin,
    new VuexPersistence({
      key: 'vuex-session',
      storage: window.sessionStorage,
      modules: ['TimetableHelper'],
    }).plugin,
  ],
})
